/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
import type { EditableCellState } from './DimeEditableCell.types.js';

export interface EditableCellDisplay {
  text: string;
  muted: boolean;
}

const EMPTY_CELL_TEXT = '—';

/**
 * The visual grammar the whole price sheet depends on: `set` renders plain, `inherited` renders
 * muted (same text, no parentheses -- the tooltip naming the source is what disambiguates it),
 * `empty` renders an em dash. Lives here — not in each consumer's column def — so every surface
 * that renders a DimeEditableCell agrees on what "inherited" looks like.
 */
export function resolveEditableCellDisplay(
  state: EditableCellState,
  formattedValue: string,
  emptyText: string = EMPTY_CELL_TEXT,
): EditableCellDisplay {
  if (state === 'empty') return { text: emptyText, muted: true };
  return { text: formattedValue, muted: state === 'inherited' };
}
